import { Spinner } from "@heroui/react";

interface LoadingScreenProps {
	message?: string;
	showSpinner?: boolean;
}

export function LoadingScreen({ 
	message = "טוען...", 
	showSpinner = true 
}: LoadingScreenProps) {
	return (
		<div role="status" className="p-8 w-full min-h-screen flex items-center justify-center">
			<div className="flex flex-col items-center gap-4">
				{showSpinner && (
					<Spinner 
						size="lg" 
						color="primary" 
						labelColor="primary"
					/>
				)}
				<div className="text-center">
					<p className="text-lg font-medium text-gray-700">{message}</p>
					<p className="text-sm text-gray-500 mt-2">אנא המתן...</p>
				</div>
			</div>
		</div>
	);
}

export function TranslationLoadingScreen() {
	return (
		<LoadingScreen 
			message="טוען תרגומים..." 
			showSpinner={true}
		/>
	);
}

export function AuthLoadingScreen() {
	return (
		<LoadingScreen 
			message="מאמת משתמש..." 
			showSpinner={true}
		/>
	);
} 